import Vue from 'vue';
import Vuex from 'vuex';
import axios from 'axios';

Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        searchActive: false,
        discoverMode: true,
        searchTerm: '',
        searchResults: null,
        mostPopular: [],
        recommended: [],
        filteredResults: [],
    },
    mutations: {
        setDiscoverMode(state, value) {
            state.discoverMode = value;
        },         
        setSearchActive(state, value) {
            state.searchActive = value;
        },        
        setSearchTerm(state, value) {
            state.searchTerm = sanitize(value);
        },
        setSearchResults: function (state, payload) {
            state.searchResults = payload;
        },
        setMostPopular: function (state, payload) {
            state.mostPopular = payload;
        },
        setRecommended: function (state, payload) {
            state.recommended = payload;
        },
        setFilteredResults: function (state, payload) {
            state.filteredResults = payload;
        },        
    },
    actions: {
        getMostPopular(context){
            axios.get('/Umbraco/Api/SearchApi/GetMostPopularSearch')
                .then((response) => {
                    let parsedData = [];
                    try { parsedData = response.data; } catch (err) { console.log("Error: ", err) } // eslint-disable-line no-empty
                    context.commit('setMostPopular', parsedData);
                });
        },             
        getRecommended(context){
            axios.get('/Umbraco/Api/SearchApi/GetRecommendedSearch')
                .then((response) => {
                    let parsedData = [];
                    try { parsedData = response.data; } catch (err) { console.log("Error: ", err) } // eslint-disable-line no-empty
                    context.commit('setRecommended', parsedData);
                });
        },        
        getSearchResults(context){
            axios.get(`/Umbraco/Api/SearchApi/GetOrderBySearch/?text=${this.state.searchTerm}`)
                .then((response) => {
                    let parsedData = [];
                    try { parsedData = response.data; } catch (err) { console.log("Error: ", err) } // eslint-disable-line no-empty
                    context.commit('setSearchResults', parsedData);
                });
        },        
    }
})

function sanitize(str) {
    return str.replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/"/g, "&quot;")
        .replace(/'/g, "&#039;");
}